export { default as fuego } from '../project'